var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMembershipsCopy = function SvgMembershipsCopy(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.36951 3.33636C9.13441 3.33636 8.94386 3.14581 8.94386 2.91072V0H5.39206C5.15697 0 4.96631 0.190552 4.96631 0.425751V2.39215H6.12543C6.23993 2.39215 6.34824 2.43851 6.42685 2.51701L9.76321 5.85349C9.83809 5.92825 9.88808 6.03635 9.88808 6.15427V11.4273H11.8545C12.0897 11.4273 12.2802 11.2367 12.2802 11.0016V3.33636H9.36951Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79517 0.60199V2.48497H11.6781L9.79517 0.60199Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69989 6.15427V3.24355H2.14841C1.91321 3.24355 1.72266 3.4342 1.72266 3.6693V13.5742C1.72266 13.8094 1.91321 14 2.14841 14H8.61082C8.84592 14 9.03658 13.8094 9.03658 13.5742V6.58002H6.12553C5.89055 6.58002 5.69989 6.38957 5.69989 6.15427Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55127 5.72852H8.43425L6.55127 3.84586V5.72852Z"
  }))));
};
export default SvgMembershipsCopy;